import { render, staticRenderFns } from "./tips_card.vue?vue&type=template&id=5c465d3c"
import script from "./tips_card.vue?vue&type=script&lang=js"
export * from "./tips_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports